import {
  STOCK_TAKING_CAR_MANAGEMENT_SELECT_IMAGE_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_SELECT_IMAGE_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_SELECT_IMAGE_FAILURE
} from '../constants'
import { BFFAgent } from 'BFFAgent'
import { REACT_APP_IMG } from '../../../../common/config'


export function addFileImage(images) {
  return async (dispatch, getState) => {
    dispatch({
      type: STOCK_TAKING_CAR_MANAGEMENT_SELECT_IMAGE_BEGIN
    })

    const { stock } = getState()
    const files = stock.takingCarManagement.fastStockLoading.saveData.files

    try {
      const imagesFormat = []
      await Promise.all(
        images.map(async image => {
          const imageInfo = await BFFAgent.Files.addFile(image)
          const urlImage = `${REACT_APP_IMG}/${imageInfo.url}`
          imagesFormat.push({ ...imageInfo, urlImage, deviceImage: true })
        })
      )
     
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_SELECT_IMAGE_SUCCESS,
        data: [...files, ...imagesFormat]
      })
    } catch {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_SELECT_IMAGE_FAILURE
      })
    }
  }
}
